export enum CollectionActionEnum {
  SELECT_COLLECTION = 'select collection',
  CREATE_COLLECTION = 'create collection',
  VERIFICATION_CODE = 'verification code',
}
